import { jsx, Fragment } from 'react/jsx-runtime';
import { createContext, useEffect } from 'react';
import { makeConsentStore, consentStore } from './_store.js';

const ConsentContext = createContext({
  hasConsented: () => {
    throw new Error(
      "Consent().hasConsented() has not been implemented. Did you forget to wrap your render tree with a ConsentProvider?"
    );
  },
  handleRequestConsent: () => {
    throw new Error(
      "Consent().handleRequestConsent() has not been implemented. Did you forget to wrap your render tree with a ConsentProvider?"
    );
  },
  subscribe: () => {
    throw new Error(
      "Consent().subscribe() has not been implemented. Did you forget to wrap your render tree with a ConsentProvider?"
    );
  }
});
function makeConsentProvider(args) {
  const getCurrentState = () => ({
    cookies: {
      necessary: args.hasConsented("cookies.necessary"),
      preferences: args.hasConsented("cookies.preferences"),
      statistics: args.hasConsented("cookies.statistics"),
      marketing: args.hasConsented("cookies.marketing")
    }
  });
  const store = makeConsentStore(getCurrentState());
  function ConsentHook(props) {
    const dispatch = consentStore.useDispatch();
    useEffect(() => {
      dispatch(consentStore.actions.updateConsent(getCurrentState()));
      return args.subscribe(() => {
        dispatch(consentStore.actions.updateConsent(getCurrentState()));
      });
    }, [dispatch]);
    return /* @__PURE__ */ jsx(Fragment, { children: props.children });
  }
  return function ConsentWrapper(props) {
    return /* @__PURE__ */ jsx(ConsentContext.Provider, { value: args, children: /* @__PURE__ */ jsx(consentStore.Provider, { store, children: /* @__PURE__ */ jsx(ConsentHook, { children: props.children }) }) });
  };
}

export { ConsentContext, makeConsentProvider };
//# sourceMappingURL=_provider.js.map
